/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFEnumerationCounter } from './CRSFEnumerationCounter';
import {
    CRSFEnumerationCounterFromJSON,
    CRSFEnumerationCounterFromJSONTyped,
    CRSFEnumerationCounterToJSON,
} from './CRSFEnumerationCounter';

/**
 * 
 * @export
 * @interface CRSFSourceCount
 */
export interface CRSFSourceCount {
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    account?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    account_sec?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    asm?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    brandsfinder?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    bvd?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    redirect?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    whois?: CRSFEnumerationCounter;
    /**
     * 
     * @type {CRSFEnumerationCounter}
     * @memberof CRSFSourceCount
     */
    zoominfo?: CRSFEnumerationCounter;
}

/**
 * Check if a given object implements the CRSFSourceCount interface.
 */
export function instanceOfCRSFSourceCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSourceCountFromJSON(json: any): CRSFSourceCount {
    return CRSFSourceCountFromJSONTyped(json, false);
}

export function CRSFSourceCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSourceCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : CRSFEnumerationCounterFromJSON(json['account']),
        'account_sec': !exists(json, 'account-sec') ? undefined : CRSFEnumerationCounterFromJSON(json['account-sec']),
        'asm': !exists(json, 'asm') ? undefined : CRSFEnumerationCounterFromJSON(json['asm']),
        'brandsfinder': !exists(json, 'brandsfinder') ? undefined : CRSFEnumerationCounterFromJSON(json['brandsfinder']),
        'bvd': !exists(json, 'bvd') ? undefined : CRSFEnumerationCounterFromJSON(json['bvd']),
        'redirect': !exists(json, 'redirect') ? undefined : CRSFEnumerationCounterFromJSON(json['redirect']),
        'whois': !exists(json, 'whois') ? undefined : CRSFEnumerationCounterFromJSON(json['whois']),
        'zoominfo': !exists(json, 'zoominfo') ? undefined : CRSFEnumerationCounterFromJSON(json['zoominfo']),
    };
}

export function CRSFSourceCountToJSON(value?: CRSFSourceCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': CRSFEnumerationCounterToJSON(value.account),
        'account-sec': CRSFEnumerationCounterToJSON(value.account_sec),
        'asm': CRSFEnumerationCounterToJSON(value.asm),
        'brandsfinder': CRSFEnumerationCounterToJSON(value.brandsfinder),
        'bvd': CRSFEnumerationCounterToJSON(value.bvd),
        'redirect': CRSFEnumerationCounterToJSON(value.redirect),
        'whois': CRSFEnumerationCounterToJSON(value.whois),
        'zoominfo': CRSFEnumerationCounterToJSON(value.zoominfo),
    };
}

